"use client";

import { useState } from "react";
import { ProjectCard } from "../_components/site";
import { projects as allProjects } from "../_data";

type Project = (typeof allProjects)[number];

const filters = [
  { key: "all", label: "Alles" },
  { key: "study", label: "Ontwerpstudies" },
  { key: "running", label: "Lopende projecten" },
] as const;

function filterProjects(filter: string, projects: readonly Project[]) {
  if (filter === "all") return projects;
  if (filter === "study") return projects.filter((p) => p.status.includes("Studie"));
  if (filter === "running") return projects.filter((p) => p.status.includes("Loopt"));
  return projects;
}

export function ProjectFilter({ projects }: { projects: readonly Project[] }) {
  const [activeFilter, setActiveFilter] = useState<string>("all");
  const visible = filterProjects(activeFilter, projects);

  return (
    <>
      <section className="filter-strip">
        <div className="shell filter-inner">
          <span>Projectstatus</span>
          {filters.map((f) => (
            <button
              key={f.key}
              className={`filter-chip${activeFilter === f.key ? " filter-chip-active" : ""}`}
              onClick={() => setActiveFilter(f.key)}
              type="button"
            >
              {f.label}
            </button>
          ))}
        </div>
      </section>
      <section className="section section-sand" id="op-de-tekentafel">
        <div className="shell">
          <div className="section-heading-row" data-reveal>
            <div>
              <span className="section-label">Op de tekentafel</span>
              <h2>Ontwerpstudies en lopende projecten.</h2>
            </div>
          </div>
          <div className="project-grid project-grid-all">
            {visible.length > 0 ? (
              visible.map((project) => <ProjectCard project={project} key={project.slug} />)
            ) : (
              <p className="project-empty">
                Hier staat nog niets. Zodra er iets te laten zien is, komt het hier.
              </p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}